var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailDocumentation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 67,
    viewBox: "0 0 75 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M47.5911 65.4254H3.50078C2.01578 65.4254 0.800781 64.2104 0.800781 62.7254V3.7C0.800781 2.215 2.01578 1 3.50078 1H52.8156C54.3006 1 55.5156 2.215 55.5156 3.7V24.2504",
    stroke: "#106C3A",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    d: "M0.800781 9.09961H55.5156",
    stroke: "#106C3A",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.0652 4.90062C6.0652 5.52162 5.56165 6.02584 4.93998 6.02584C4.31898 6.02584 3.81543 5.52162 3.81543 4.90062C3.81543 4.27962 4.31898 3.77539 4.93998 3.77539C5.56165 3.77539 6.0652 4.27962 6.0652 4.90062Z",
    fill: "#106C3A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8904 4.90013C9.8904 5.52113 9.38685 6.02535 8.76517 6.02535C8.14417 6.02535 7.64062 5.52113 7.64062 4.90013C7.64062 4.27913 8.14417 3.7749 8.76517 3.7749C9.38685 3.7749 9.8904 4.27913 9.8904 4.90013Z",
    fill: "#106C3A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9402 4.90062C13.9402 5.52162 13.4367 6.02584 12.815 6.02584C12.194 6.02584 11.6904 5.52162 11.6904 4.90062C11.6904 4.27962 12.194 3.77539 12.815 3.77539C13.4367 3.77539 13.9402 4.27962 13.9402 4.90062Z",
    fill: "#106C3A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.2469 47.5745C38.1051 47.5745 37.9634 47.5198 37.8547 47.4125L30.7078 40.2649C30.4918 40.0482 30.4918 39.6972 30.7085 39.4799C30.9245 39.2645 31.2762 39.2632 31.4928 39.4799L38.6391 46.6274C38.8564 46.8434 38.8564 47.1944 38.6391 47.4125C38.5311 47.5198 38.3886 47.5745 38.2469 47.5745Z",
    fill: "#106C3A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4951 47.5745C15.3534 47.5745 15.2109 47.5198 15.1029 47.4125C14.8863 47.1945 14.8863 46.8435 15.1029 46.6275L22.2492 39.4799C22.4658 39.2632 22.8175 39.2632 23.0342 39.4799C23.2509 39.6972 23.2509 40.0482 23.0342 40.2649L15.888 47.4125C15.7793 47.5198 15.6375 47.5745 15.4951 47.5745Z",
    fill: "#106C3A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3804 47.8641H16.342C15.2357 47.8641 14.3359 46.9644 14.3359 45.858V30.6233C14.3359 29.517 15.2357 28.6172 16.342 28.6172H30.1363C30.4428 28.6172 30.6912 28.8656 30.6912 29.172C30.6912 29.4785 30.4428 29.7276 30.1363 29.7276H16.342C15.8479 29.7276 15.4463 30.1292 15.4463 30.6233V45.858C15.4463 46.3521 15.8479 46.7538 16.342 46.7538H37.3804C37.8745 46.7538 38.2762 46.3521 38.2762 45.858V38.1772C38.2762 37.8701 38.5252 37.6224 38.831 37.6224C39.1381 37.6224 39.3865 37.8701 39.3865 38.1772V45.858C39.3865 46.9644 38.4868 47.8641 37.3804 47.8641Z",
    fill: "#106C3A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8612 44.0666C26.3253 44.0666 25.8217 43.858 25.4424 43.4793L14.4986 32.5349C14.394 32.4309 14.3359 32.2892 14.3359 32.1434V30.6233C14.3359 29.517 15.2357 28.6172 16.342 28.6172H30.1363C30.4428 28.6172 30.6912 28.8649 30.6912 29.1714C30.6912 29.4778 30.4428 29.7276 30.1363 29.7276H16.342C15.8479 29.7276 15.4463 30.1285 15.4463 30.6233V31.9125L26.2274 42.695C26.3968 42.8644 26.6216 42.9569 26.8612 42.9569C27.1002 42.9569 27.325 42.8644 27.4951 42.695L33.4945 36.6949C33.7111 36.4782 34.0628 36.4782 34.2795 36.6949C34.4962 36.9116 34.4962 37.2626 34.2795 37.4799L28.2794 43.4793C27.9007 43.858 27.3972 44.0666 26.8612 44.0666Z",
    fill: "#106C3A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4445 26.663C35.3537 26.663 36.0895 27.3995 36.0895 28.3033V34.8974C36.0895 35.191 36.3284 35.4299 36.622 35.4299H40.6126C40.9063 35.4299 41.1459 35.191 41.1459 34.8974V28.3033C41.1459 27.3995 41.8816 26.663 42.7855 26.663L45.4173 26.6718L42.9623 24.0434C42.5526 23.6046 41.8864 22.8824 41.4814 22.4409L38.9413 19.6619C38.7638 19.4669 38.4709 19.4669 38.2927 19.6619L35.7533 22.4409C35.3483 22.8824 34.6821 23.6046 34.273 24.0434L31.8174 26.6718L34.4445 26.663ZM40.6129 36.5403H36.6223C35.7164 36.5403 34.9793 35.8032 34.9793 34.8974V28.3033C34.9793 28.0117 34.7417 27.7734 34.4495 27.7734L31.6259 27.7822C30.8895 27.7822 30.6384 27.3867 30.5648 27.2166C30.4906 27.0458 30.3725 26.5929 30.8733 26.0562L33.4613 23.2854C33.869 22.8493 34.5318 22.1325 34.9341 21.691L37.4735 18.9134C37.7752 18.582 38.1815 18.4004 38.6176 18.4004C39.053 18.4004 39.46 18.582 39.761 18.9134L42.3011 21.691C42.7034 22.1325 43.3662 22.8493 43.7739 23.2854L46.3619 26.0562C46.8627 26.5929 46.7446 27.0458 46.6703 27.2166C46.5968 27.3867 46.3457 27.7822 45.6153 27.7822L42.7877 27.7734C42.4934 27.7734 42.2558 28.0117 42.2558 28.3033V34.8974C42.2558 35.8032 41.5187 36.5403 40.6129 36.5403Z",
    fill: "#106C3A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.1052 65.4255H53.8563C52.3713 65.4255 51.1562 64.2105 51.1562 62.7255V30.1736C51.1562 28.688 52.3713 27.4736 53.8563 27.4736H71.1052C72.5902 27.4736 73.8052 28.688 73.8052 30.1736V62.7255C73.8052 64.2105 72.5902 65.4255 71.1052 65.4255Z",
    stroke: "#106C3A",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.0926 61.5904C64.0926 62.4807 63.3711 63.2023 62.4807 63.2023C61.5904 63.2023 60.8682 62.4807 60.8682 61.5904C60.8682 60.7001 61.5904 59.9785 62.4807 59.9785C63.3711 59.9785 64.0926 60.7001 64.0926 61.5904Z",
    fill: "#106C3A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailDocumentation);
export default __webpack_public_path__ + "static/media/email_documentation.06699ea5cbd59eb21fd2216b0b6a3d25.svg";
export { ForwardRef as ReactComponent };